import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { forgotPassword } from '../http/userAPI';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    try {
      await forgotPassword(email);
      setSuccess('Письмо для восстановления пароля отправлено. Проверьте почту!');
    } catch (e) {
      setError(e?.response?.data?.message || 'Ошибка при отправке письма');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center auth-container" style={{ minHeight: '100vh' }}>
      <Card className="p-4 auth-card">
        <h2 className="m-auto mb-4">Восстановление пароля</h2>
        <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
          <Form.Control
            placeholder="Введите ваш email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <Button type="submit" variant="outline-primary" disabled={loading}>
            {loading ? 'Отправка...' : 'Восстановить пароль'}
          </Button>
          {success && <Alert variant="success">{success}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}
        </Form>
        <div className="mt-3 text-center">
          <Button variant="link" onClick={() => navigate('/login')}>Вернуться к входу</Button>
        </div>
      </Card>
    </Container>
  );
};

export default ForgotPassword; 